import React from 'react';
import { Images } from '../../app-constants';
import ImageIcon from './image-icon';

const ApplySearch = () => (
  <ImageIcon src={Images.ApplySearch} alt="apply-search" />
);

export default ApplySearch;
